// extracted by mini-css-extract-plugin
export default {"reset-block":"resetEmailDrawer_reset-block__Wi+9C","form-input-block":"resetEmailDrawer_form-input-block__aIN+C","reset-button":"resetEmailDrawer_reset-button__eZqdB"};